module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/* Html5Player Widget */
(function (fox, $) {
	"use strict";

	require('./banner')(fox);

	fox.registerWidget('Html5Player_StartBanner', {
		setBanner: function() {
			var img = this.rwom1('@parent @parent').getOption('onStartPlayerImage');

			if (img) {
				
				this.setOption('manualRender', false);

				this.setTemplateOptions({
					startBanner: img
				});
				this.render();
			}
		}

	}, 'Html5Player_Banner');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/widget/startBanner.js
// module id = 531
// module chunks = 4